export default "__VITE_ASSET__ba1fc60f__"